let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gEXZZ")).then(() => parcelRequire('1TJcy'));